<div class="chapter-dashboard">
  <!-- Dashboard View -->
  <div>
    <!-- Loading State -->
    <div *ngIf="isLoading" class="chapter-dashboard__loading">
      <acs-loading-spinner size="large" message="Loading dashboard data..." />
    </div>

    <!-- Error State -->
    <acs-alert 
      *ngIf="error" 
      type="error" 
      title="Error Loading Dashboard"
      [message]="error" 
      [dismissible]="true"
      (dismissed)="error = null">
    </acs-alert>

    <!-- Main Dashboard Content -->
    <div *ngIf="!isLoading" class="chapter-dashboard__content">
    
      <!-- Header Section -->
      <div class="chapter-dashboard__header">
        <div class="chapter-dashboard__title-section">
          <h1 class="chapter-dashboard__title">Chapter Dashboard</h1>
          <p class="chapter-dashboard__subtitle">
            Welcome back, {{ currentUser.FirstLast || 'User' }}! 
            <span class="chapter-dashboard__role" *ngIf="userRole">({{ userRole }})</span>
          </p>
        </div>
      </div>

      <!-- Summary Cards Section -->
      <div class="chapter-dashboard__summary">
        <acs-summary 
          [summaryCards]="summaryCards"
          [gridColumns]="4"
          cardSize="medium"
          spacing="normal" />
      </div>

    </div>
  </div>
</div>